import {createApp} from 'vue';
document.addEventListener('DOMContentLoaded', function() {
  /**============================================================
  *   [form] agree-checkbox
  *   description : チェックボックス後ボタンの活性・非活性を変更する処理を記述
  ============================================================*/
  if(document.getElementById('js-agree')){
    const policyCheck = createApp({
      data() {
        return {
          isChecked: false,
        }
      }
    })
    policyCheck.mount('#js-agree');
  }
  /**============================================================
  *   [form] select
  *   description : selectのvalueが空の時にテキスト色を変更する処理を記述
  ============================================================*/
  if(document.querySelectorAll('select').length > 0){
    const selects = document.querySelectorAll('select');
    selects.forEach(select => {

      if (select.value !== '') {
        select.classList.remove('is-value-empty');
      }else{
        select.classList.add('is-value-empty');
      }

      select.addEventListener('change', (e) => {
        if (e.target.value !== '') {
          select.classList.remove('is-value-empty');
        }else{
          select.classList.add('is-value-empty');
        }
      })

    })
  }
})
